package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Close
import androidx.compose.material3.Icon
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.util.toScaleDp


@Composable
fun SelectedChip(item: String, onRemove: () -> Unit, allowRemove: Boolean = true) {
    Surface(
        shape = boxCornerShape(),
        color = MaterialTheme.colors.primary.copy(alpha = 0.2f)
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .padding(horizontal = 8.toScaleDp(), vertical = 4.toScaleDp())
        ) {
            Text(
                text = item,
                color = MaterialTheme.colors.primary,
                modifier = Modifier.padding(end = 4.toScaleDp())
            )
            if (allowRemove) {
                Icon(
                    imageVector = Icons.Default.Close,
                    contentDescription = "Remove",
                    modifier = Modifier.size(16.toScaleDp())
                        .noRippleClickable(onRemove)
                        .pointerHoverIcon(PointerIcon.Hand),
                    tint = MaterialTheme.colors.primary
                )
            }
        }
    }
}